import { Button, Tag } from 'antd'
import { BellOutlined, ClockCircleOutlined, FileTextOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import * as S from './styles'

const dataBr = (v) => (v ? dayjs(v).format('DD/MM/YYYY') : '')
const brl = (v) => Number(v).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
const FONTE = { pdpj: 'PDPJ', esaj: 'e-SAJ', datajud: 'DataJud' }

function Secao({ icone, titulo, children }) {
  return (
    <div style={{ marginTop: 12 }}>
      <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--yrm-text-2)', textTransform: 'uppercase', letterSpacing: '.04em', marginBottom: 6 }}>
        {icone} {titulo}
      </div>
      {children}
    </div>
  )
}

// Cartão do processo no chat: capa, andamentos, intimações e prazos (animados)
export default function CartaoProcesso({ painel, onResumir, resumindo }) {
  if (!painel) return null
  const { processo: p, movimentos = [], intimacoes = [], prazos = [] } = painel
  const capa = [
    ['Cliente', p.cliente], ['Juiz', p.juiz], ['Vara', p.vara], ['Comarca', p.comarca],
    ['Valor da causa', p.valorCausa ? brl(p.valorCausa) : null], ['Fase', p.fase],
  ].filter(([, v]) => v)
  return (
    <S.Cartao aria-label={`Processo ${p.numero}`}>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'flex-start' }}>
        <div>
          <div style={{ fontWeight: 700, fontSize: 15, color: 'var(--yrm-text)' }}>{p.numero}</div>
          <div style={{ fontSize: 12, color: 'var(--yrm-text-3)' }}>{[p.classe, p.assunto].filter(Boolean).join(' · ')}</div>
        </div>
        {p.resultado && <Tag color={p.resultado === 'perdido' ? 'volcano' : 'blue'} style={{ margin: 0 }}>{p.resultado}</Tag>}
      </div>
      {capa.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px 12px', marginTop: 10 }}>
          {capa.map(([k, v], i) => (
            <S.ItemAnimado key={k} $i={i}>
              <div style={{ fontSize: 12, color: 'var(--yrm-text-3)' }}>{k}</div>
              <div style={{ fontSize: 13, color: 'var(--yrm-text)' }}>{v}</div>
            </S.ItemAnimado>
          ))}
        </div>
      )}

      {prazos.length > 0 && (
        <Secao icone={<ClockCircleOutlined />} titulo="Prazos">
          {prazos.map((z, i) => (
            <S.ItemAnimado key={i} $i={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, padding: '3px 0' }}>
              <span>{z.ato || 'Prazo'}</span>
              <Tag color={z.status === 'pendente' ? 'orange' : 'green'} style={{ margin: 0 }}>fatal {dataBr(z.fatal)}</Tag>
            </S.ItemAnimado>
          ))}
        </Secao>
      )}

      {intimacoes.length > 0 && (
        <Secao icone={<BellOutlined />} titulo="Intimações">
          {intimacoes.slice(0, 3).map((x, i) => (
            <S.ItemAnimado key={x.id || i} $i={i} style={{ fontSize: 13, padding: '6px 8px', background: 'var(--yrm-surface-2)', borderRadius: 8, marginBottom: 6 }}>
              <div style={{ fontSize: 12, color: 'var(--yrm-text-3)' }}>{dataBr(x.data)} · {x.diario}</div>
              <div>{x.texto}</div>
            </S.ItemAnimado>
          ))}
        </Secao>
      )}

      {movimentos.length > 0 && (
        <Secao icone={<FileTextOutlined />} titulo="Últimos andamentos">
          <div style={{ borderLeft: '2px solid #c7d2fe', marginLeft: 4, paddingLeft: 12 }}>
            {movimentos.slice(0, 6).map((m, i) => (
              <S.ItemAnimado key={i} $i={i} style={{ position: 'relative', padding: '4px 0', fontSize: 13 }}>
                <span style={{ position: 'absolute', left: -17, top: 9, width: 8, height: 8, borderRadius: 99, background: m.nova ? '#ef4444' : '#2563eb' }} />
                <span style={{ color: 'var(--yrm-text-3)', fontSize: 12 }}>{dataBr(m.data)}{FONTE[m.fonte] ? ` · ${FONTE[m.fonte]}` : ''}{m.nova ? ' · nova' : ''}</span>
                <div>{m.texto}</div>
              </S.ItemAnimado>
            ))}
          </div>
        </Secao>
      )}

      <Button type="primary" ghost block style={{ marginTop: 12 }} loading={resumindo} onClick={onResumir}>
        ✨ Resumir processo e próximos passos
      </Button>
    </S.Cartao>
  )
}
